import { cn } from '@/lib/utils';
import type { PostGridObjectStatus } from '@/services/api/generated/postgridService';

import { getStatusConfig } from './statusConfig';

interface StatusBadgeProps {
  status?: PostGridObjectStatus;
  className?: string;
}

const StatusBadge = ({ status, className }: StatusBadgeProps) => {
  if (!status) {
    return (
      <span
        className={cn(
          'inline-flex items-center px-2 py-1 text-xs font-medium rounded-md',
          'bg-gray-50 text-gray-700 border border-gray-200',
          className,
        )}
      >
        Unknown
      </span>
    );
  }

  const config = getStatusConfig(status);

  return (
    <span
      className={cn(
        'inline-flex items-center px-2 py-1 text-xs font-medium rounded-md',
        config.badgeClassName,
        className,
      )}
    >
      {config.label}
    </span>
  );
};

export { StatusBadge };
